var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"p-3 font-weight-regular",class:[_vm.statusColor(_vm.status), { chipTable: _vm.small ? 'v-chip--table' : '' }]},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }